import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
    CmpsButtonModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { ToolbarComponent } from './toolbar.component';

@NgModule({
    declarations: [ToolbarComponent],
    exports: [ToolbarComponent],
    imports: [
        CmpsButtonModule,
        CmpsTooltipModule,
        CmpsIconModule,
        CommonModule,
    ],
})
export class CmpsCaEvaluationToolbarModule {}
